import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import ErrorCard from '../Common/ErrorCard';

export const NoAuthServer = () => {
    const [params] = useSearchParams()

    return <ErrorCard details="" message={"Authentication server not found: " + params.get("authority") + ". Please try log in again."} />

    // return (
    //     <div className="danger" role="alert">
    //         Authentication Server Not Found ({params.get("authority")})

    //         <p><Button icon='refresh' onClick={() => navigate('/')}>Retry</Button></p>
    //     </div>

    // )
}

export const NoApiServer = () => {
    const [params] = useSearchParams()

    return <ErrorCard details="Check your internet connection and try again. If the error perists, please contact your system administrator." message={"Unable to connect to the Revelation helpdesk API : " + params.get("url")} />

} 